import Config from '../Config';
import {RestService} from './RestService';

export const DispositionService = {
    getDispositions: async function(headers = {}){
        return RestService.get(Config.list_dispositions, headers)
                .then(response => response.json());
    },
};